import req from '../../api/request'
import type { SnEvent } from '../../features/event/types'

/** Permission flags the API returns per entity in `meta.permissions[id]`. */
export interface EntityPermission {
  admin?: boolean
  view?: boolean
  viewAny?: boolean
  update?: boolean
  delete?: boolean
  post?: boolean
  member?: boolean
}

export interface GetEventResult {
  event: SnEvent | null
  /**
   * `meta.permissions[eventId]` when the API sends it, otherwise null.
   *
   * Events have no permissions of their own — every check runs against the
   * parent team — so this may legitimately be absent, in which case callers
   * fall back to the team's own permissions.
   */
  permission: EntityPermission | null
}

/**
 * A single event by id, plus whatever permission metadata came with it.
 *
 * `meta` is deliberately surfaced rather than discarded: most SportNinja reads
 * carry `meta.permissions[id]`, and using it avoids a second request just to
 * decide whether to show edit/delete.
 */
export const getEvent = async (eventId: string): Promise<GetEventResult> => {
  const response = await req(`/events/${eventId}`)
  return {
    event: (response?.data ?? null) as SnEvent | null,
    permission: (response?.meta?.permissions?.[eventId] ??
      null) as EntityPermission | null,
  }
}
